module.exports = __webpack_public_path__ + "media/images/pic/production-hall-c516d2a4866b1b18239a4b282835a18c.webp";